
// Global Configuration and Constants for Cribbage Board Customizer

const DPI = 96;
const CPM = 1.25;
const textFree = 2;
const perLane = 10;
const designNamePrefix = "customizer-";
const scaleBy = 1.1; // How much to zoom in/out with each scroll step
const intervalDelay = 10;
const longPressDelay = 500; // milliseconds
const autoLoadDesign = true;
const engraveColor = "#1d0200";
const transparentColor = "transparent";
let lastFont = "Arial";
const inch = 72;
const resizeIncrement = inch;
const maxBaseBoardWidth = 24;  // in inches
const maxBaseBoardHeight = 16; // in inches
const boardFeetInches = 144; // 12in x 12in = 144in² per board foot
//const GUIDELINE_OFFSET = 10; // Snap tolerance in pixels

// Initial base board configuration
// Note: This is mutable state, but defining the initial structure here.
let baseBoardConfig = {
  canChooseTrack: null,
  width: null,
  length: null
};

const pegSizes = [
  {
    name: "1/8",
    value: 0.125,
    scale: 1
  },
  {
    name: "3/32",
    value: 0.09375,
    scale: .75
  },
  {
    name: "5/64",
    value: 0.078125,
    scale: .625
  },
  {
    name: "3/16",
    value: 0.1875,
    scale: 1.5
  },
  {
    name: "1/4",
    value: 0.25,
    scale: 2
  },
  {
    name: "3/8",
    value: 0.375,
    scale: 3
  },
  {
    name: "1/2",
    value: 0.5,
    scale: 4
  },
];

// Calculated rotation snaps
let rotSnaps = [];
for (let r = 0; r < 360; r += 45) {
  rotSnaps.push(r);
}

const stainFilters = [
  {
    name: "Clear"
  },
  {
    name: "Light Brown",
    red: 235,
    blue: 78,
    green: 152
  },
  {
    name: "Dark Brown",
    red: 55,
    blue: 4,
    green: 34
  },
  {
    name: "Gunstock",
    red: 255,
    blue: 31,
    green: 95
  },
  {
    name: "Grey",
    red: 160,
    blue: 160,
    green: 160
  },
  {
    name: "Ebony",
    red: 40,
    blue: 40,
    green: 40
  }
];
